/**
 * Toast / bagel / muffin tabs synced to <product-carousel> for banner 3.
 */
if (!customElements.get('two-toaster-ver2-banner3')) {
  class TwoToasterVer2Banner3 extends HTMLElement {
    /** @type {NodeListOf<HTMLButtonElement> | null} */
    _buttons = null;
    /** @type {HTMLElement | null} */
    _carousel = null;
    /** @type {number} */
    _tries = 0;

    /** @type {boolean} */
    _swiperBound = false;

    /** @type {SwiperInstance | null} */
    _boundSwiper = null;

    /** @type {number | null} */
    _waitRafId = null;

    /** @type {number | null} */
    _waitTimeoutId = null;

    connectedCallback() {
      this._buttons = this.querySelectorAll('.two-toaster-ver2__banner3__btn-group button');
      this._carousel = this.querySelector('product-carousel');
      if (!this._buttons.length || !this._carousel) return;

      this._onButtonClick = this._onButtonClick.bind(this);
      this._onSlideChange = this._onSlideChange.bind(this);

      this._buttons.forEach((button) => {
        button.addEventListener('click', this._onButtonClick);
      });

      this._tries = 0;
      this._waitForSwiper();
    }

    disconnectedCallback() {
      this._clearSwiperWait();
      this._buttons?.forEach((button) => {
        button.removeEventListener('click', this._onButtonClick);
      });
      this._detachSwiperListener();
      this._tries = 0;
    }

    _clearSwiperWait() {
      if (this._waitRafId != null) {
        cancelAnimationFrame(this._waitRafId);
        this._waitRafId = null;
      }
      if (this._waitTimeoutId != null) {
        clearTimeout(this._waitTimeoutId);
        this._waitTimeoutId = null;
      }
    }

    _detachSwiperListener() {
      this._boundSwiper?.off?.('slideChange', this._onSlideChange);
      this._boundSwiper = null;
      this._swiperBound = false;
    }

    _bindSwiperListener(swiper) {
      if (this._swiperBound && this._boundSwiper === swiper) return;

      this._boundSwiper?.off?.('slideChange', this._onSlideChange);
      swiper.off?.('slideChange', this._onSlideChange);
      swiper.on('slideChange', this._onSlideChange);
      this._boundSwiper = swiper;
      this._swiperBound = true;
    }

    _waitForSwiper() {
      const swiper = this._carousel?.swiper;
      if (swiper) {
        this._clearSwiperWait();
        this._bindSwiperListener(swiper);
        this._syncButtons(swiper.activeIndex);
        return;
      }

      this._tries += 1;
      if (this._tries > 80) return;
      if (this._tries < 10) {
        this._waitRafId = requestAnimationFrame(() => {
          this._waitRafId = null;
          this._waitForSwiper();
        });
      } else {
        this._waitTimeoutId = window.setTimeout(() => {
          this._waitTimeoutId = null;
          this._waitForSwiper();
        }, 25);
      }
    }

    _onButtonClick(event) {
      const button = event.currentTarget;
      const index = Array.prototype.indexOf.call(this._buttons, button);
      if (index < 0) return;
      this._carousel?.swiper?.slideTo(index);
    }

    _onSlideChange() {
      const index = this._carousel?.swiper?.activeIndex;
      if (index == null) return;
      this._syncButtons(index);
    }

    _syncButtons(index) {
      this._buttons?.forEach((button, i) => {
        const active = i === index;
        button.classList.toggle('active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
  }

  customElements.define('two-toaster-ver2-banner3', TwoToasterVer2Banner3);
}
